import { Timeline } from './../_models/timeline';
import { Observable } from 'rxjs/Observable';
import { Pet } from './../_models/pet';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { Injectable } from '@angular/core';
import { Vaccine } from '../_models/vaccine';

@Injectable()
export class PetsService {

  private petsCollection: AngularFirestoreCollection<Pet>;

  constructor(
    private _firestore: AngularFirestore
  ) {
  }

  /**
  *
  */
  getGuardianPets(guardianEmail: string): Observable<Pet[]> {
    this.petsCollection = this._firestore.collection<Pet>('pets', ref =>
      ref
        .where('guardian.user.email', '==', guardianEmail)
    );

    return this.petsCollection.snapshotChanges().map(o => {
      return o.map(item => {
        const data = item.payload.doc.data();
        const uuid = item.payload.doc.id;

        if (data.birthday) {
          if (typeof data.birthday.toDate === 'function') {
            data.birthday = data.birthday.toDate();
          }
        }

        if (data.date) {
          if (typeof data.date.toDate === 'function') {
            data.date = data.date.toDate();
          }
        }

        return new Pet({ ...{ uuid: uuid }, ...data });
      });
    });

  }

  deletePet(pet: Pet) {
    return this._firestore.doc(`pets/${pet.uuid}`).delete();
  }

  /**
   *
   */
  getPets(): Observable<Pet[]> {

    this.petsCollection = this._firestore.collection<Pet>('pets', ref =>
      ref
        .orderBy('name', 'asc')
    );

    return this.petsCollection.snapshotChanges().map(o => {
      return o.map(item => {
        const data = item.payload.doc.data();
        const uuid = item.payload.doc.id;

        if (data.birthday) {
          if (typeof data.birthday.toDate === 'function') {
            data.birthday = data.birthday.toDate();
          }
        }

        if (data.date) {
          if (typeof data.date.toDate === 'function') {
            data.date = data.date.toDate();
          }
        }

        return new Pet({ ...{ uuid: uuid }, ...data });
      });
    });

  }

  /**
   *
   * @param uuid
   */
  getVaccines(uuid: string): AngularFirestoreCollection<Vaccine> {
    const docVaccine = this._firestore.doc<Pet>(`/pets/${uuid}`);
    return docVaccine.collection<Vaccine>('vaccine', ref => ref);
  }

  /**
   *
   * @param uuid
   */
  getPet(uuid: string) {
    return this._firestore.doc<Pet>('pets/' + uuid);
  }

  /**
  * Retorna objeto Pet a partir do ID informado (com ID Firebase concatenado)
  * @param uuid
  */
  getPetById(uuid: string) {
    return this._firestore.doc<Pet>('pets/' + uuid).snapshotChanges().map(petObj => {
      const data = petObj.payload.data();
      const id = petObj.payload.id;
      return new Pet({ ...{ uuid: id }, ...data });
    });
  }

  /**
  * Atualiza Guardian do pet no sistema
  * @param userId ID do User (Guardian)
  */
  updatePetGuardian(userId: string, guardian: object) {
    return this._firestore
      .collection('users')
      .doc(userId)
      .set({ guardian: guardian }, { merge: true });
  }

  /**
  * Inserir um novo pet no sistema
  * @param pet parâmetro de pet
  */
  insertPet(pet: Pet) {
    return this._firestore
      .collection('pets')
      .add(pet.toFirebase());
  }

  /**
  * Atualizar pet no sistema
  * @param vet parâmetro de veterinário
  */
  updatePet(pet: Pet, uuid: any) {
    return this._firestore
      .collection('pets')
      .doc(uuid)
      .set(
        {
          birthday: pet.birthday,
          breed: {
            name: pet.breed.name,
            uuid: pet.breed.uuid
          },
          color: pet.color,
          gender: {
            name: pet.gender.name,
            uuid: pet.gender.uuid
          },
          // guardian: {
          //   address: {
          //     addressDetail: pet.guardian.address.addressDetail,
          //     city: pet.guardian.address.city,
          //     neighborhood: pet.guardian.address.neighborhood,
          //     state: pet.guardian.address.state,
          //     street: pet.guardian.address.street,
          //     streetNumber: pet.guardian.address.streetNumber,
          //     zipcode: pet.guardian.address.zipcode
          //   },
          //   birthday: pet.guardian.birthday,
          //   document: pet.guardian.document,
          //   name: pet.guardian.name,
          //   phone: pet.guardian.phone,
          // },
          name: pet.name,
          note: pet.note,
          pelage: {
            name: pet.pelage.name,
            uuid: pet.pelage.uuid
          },
          species: {
            name: pet.species.name,
            uuid: pet.species.uuid
          },
        }, { merge: true }
      );
  }

  /**
     * Atualizar pet no sistema
     * @param vet parâmetro de veterinário
     */
  updatePetObj(pet: any, uuid: any) {

    return this._firestore
      .collection('pets')
      .doc(uuid)
      .update(pet);

  }

  /**
   *
   * @param specie
   */
  getBreeds(specie) {

    const specieDoc = this._firestore
      .collection('species')
      .doc(specie);

    // console.log('specieDoc', specieDoc);

    return specieDoc.ref.get().then(doc => {
      if (doc.exists) {
        return specieDoc.collection('breeds').ref.orderBy('name', 'asc').get(); /* .then(result => {
          result.forEach(function (item) {
            // doc.data() is never undefined for query doc snapshots
            return { id: item.id, ...item.data() };
          });
        });*/
      } else {
        return null;
      }
    });

    // this._firestore.collection('species')
    //   .doc(specie)
    //   .collection('breeds')
    //   .get()
    //   .then(function (querySnapshot) {
    //   })
    //   .catch(function (error) {
    //     console.log('Error getting user: ', error);
    //   });

  }

  /**
   *
   * @param pet
   * @param timeline
   */
  insertTimeline(pet: Pet, timeline: Timeline) {
    return this
      ._firestore
      .collection('pets')
      .doc(pet.uuid)
      .collection('timeline')
      .add(JSON.parse(JSON.stringify(timeline)));
  }

  insertProfilePhoto(pet: Pet, photoUrl: string) {
    return this
      ._firestore
      .collection('pets')
      .doc(pet.uuid)
      .set({
        photoUrl: photoUrl
      }, { merge: true });
  }

  /**
  *
  * @param pet
  * @param timeline
  */
  removeItemFromTimeline(pet: Pet, timeline: Timeline) {
    return this
      ._firestore
      .collection('pets')
      .doc(pet.uuid)
      .collection('timeline')
      .doc(timeline.uuid)
      .delete();
  }

  getTimeline(pet: Pet): AngularFirestoreCollection<Timeline> {

    return this._firestore
      .collection<Timeline>('pets/' + pet.uuid + '/timeline/', ref =>
        ref
          .orderBy('photo', 'asc'));
    /*
.snapshotChanges().map(o => {
  return o.map(item => {
    const data = item.payload.doc.data();
    const uuid = item.payload.doc.id;
    return new Timeline({ ...{ uuid: uuid }, ...data });
  });
});*/
  }

  getLastTimelinePhoto(pet: Pet) {
    return this._firestore
      .collection<Timeline>('pets/' + pet.uuid + '/timeline/')
      .ref
      .where('type', '==', 'photo')
      .orderBy('photo', 'asc')
      .limit(1)
      .get();
  }

  /**
   *
  insertBreeds() {

    // const racasCaninas = {
    //   '1': {
    //     'id': '1',
    //     'raca': 'Affenpinscher'
    //   },
    //   '2': {
    //     'id': '2',
    //     'raca': 'Afghan Hound'
    //   },
    //   '3': {
    //     'id': '3',
    //     'raca': 'Airedale Terrier'
    //   },
    //   '4': {
    //     'id': '4',
    //     'raca': 'Akita'
    //   },
    //   '5': {
    //     'id': '5',
    //     'raca': 'Akita Americano'
    //   },
    //   '6': {
    //     'id': '6',
    //     'raca': 'American Pit Bull Terrier'
    //   },
    //   '7': {
    //     'id': '7',
    //     'raca': 'American Staffordshire Terrier'
    //   },
    //   '8': {
    //     'id': '8',
    //     'raca': 'Australian Shepherd'
    //   },
    //   '9': {
    //     'id': '9',
    //     'raca': 'Basenji'
    //   },
    //   '10': {
    //     'id': '10',
    //     'raca': 'Basset Fulvo da Bretanha'
    //   },
    //   '11': {
    //     'id': '11',
    //     'raca': 'Basset Hound'
    //   },
    //   '12': {
    //     'id': '12',
    //     'raca': 'Beagle'
    //   },
    //   '13': {
    //     'id': '13',
    //     'raca': 'Beagle-Harrier'
    //   },
    //   '14': {
    //     'id': '14',
    //     'raca': 'Bearded Collie'
    //   },
    //   '15': {
    //     'id': '15',
    //     'raca': 'Bedlington Terrier'
    //   },
    //   '16': {
    //     'id': '16',
    //     'raca': 'Bernese Mountain Dog'
    //   },
    //   '17': {
    //     'id': '17',
    //     'raca': 'Bichon Bolonhês'
    //   },
    //   '18': {
    //     'id': '18',
    //     'raca': 'Bichon Frisé'
    //   },
    //   '19': {
    //     'id': '19',
    //     'raca': 'Bichon Havanês'
    //   },
    //   '20': {
    //     'id': '20',
    //     'raca': 'Billy'
    //   },
    //   '21': {
    //     'id': '21',
    //     'raca': 'Boerboel'
    //   },
    //   '22': {
    //     'id': '22',
    //     'raca': 'Boiadeiro de Entlebuch'
    //   },
    //   '23': {
    //     'id': '23',
    //     'raca': 'Border Collie'
    //   },
    //   '24': {
    //     'id': '24',
    //     'raca': 'Border Terrier'
    //   },
    //   '25': {
    //     'id': '25',
    //     'raca': 'Borzoi'
    //   },
    //   '26': {
    //     'id': '26',
    //     'raca': 'Boston Terrier'
    //   },
    //   '27': {
    //     'id': '27',
    //     'raca': 'Bouvier de Flandres'
    //   },
    //   '28': {
    //     'id': '28',
    //     'raca': 'Boxer'
    //   },
    //   '29': {
    //     'id': '29',
    //     'raca': 'Braco Alemão Pelo Curto'
    //   },
    //   '30': {
    //     'id': '30',
    //     'raca': 'Braco Alemão Pelo Duro'
    //   },
    //   '31': {
    //     'id': '31',
    //     'raca': 'Braco Italiano'
    //   },
    //   '32': {
    //     'id': '32',
    //     'raca': 'Mastim Espanhol'
    //   },
    //   '33': {
    //     'id': '33',
    //     'raca': 'Buldogue Americano'
    //   },
    //   '34': {
    //     'id': '34',
    //     'raca': 'Buldogue Campeiro'
    //   },
    //   '35': {
    //     'id': '35',
    //     'raca': 'Buldogue Francês'
    //   },
    //   '36': {
    //     'id': '36',
    //     'raca': 'Buldogue Serrano'
    //   },
    //   '37': {
    //     'id': '37',
    //     'raca': 'Bull Terrier'
    //   },
    //   '38': {
    //     'id': '38',
    //     'raca': 'Buldogue Inglês'
    //   },
    //   '39': {
    //     'id': '39',
    //     'raca': 'Bullmastiff'
    //   },
    //   '40': {
    //     'id': '40',
    //     'raca': 'Cairn Terrier'
    //   },
    //   '41': {
    //     'id': '41',
    //     'raca': 'Cane Corso'
    //   },
    //   '42': {
    //     'id': '42',
    //     'raca': 'Cão D’água Espanhol'
    //   },
    //   '43': {
    //     'id': '43',
    //     'raca': 'Cão D’água Português'
    //   },
    //   '44': {
    //     'id': '44',
    //     'raca': 'Cão da Serra da Estrela'
    //   },
    //   '45': {
    //     'id': '45',
    //     'raca': 'Cão de Castro Laboreiro'
    //   },
    //   '46': {
    //     'id': '46',
    //     'raca': 'Cão de Crista Chinês'
    //   },
    //   '47': {
    //     'id': '47',
    //     'raca': 'Cão de Santo Humberto'
    //   },
    //   '48': {
    //     'id': '48',
    //     'raca': 'Cão Fila de São Miguel'
    //   },
    //   '49': {
    //     'id': '49',
    //     'raca': 'Cão Lobo Checoslovaco'
    //   },
    //   '50': {
    //     'id': '50',
    //     'raca': 'Cão Pelado Mexicano'
    //   },
    //   '51': {
    //     'id': '51',
    //     'raca': 'Cão Pelado Peruano'
    //   },
    //   '52': {
    //     'id': '52',
    //     'raca': 'Cavalier King Charles Spaniel'
    //   },
    //   '53': {
    //     'id': '53',
    //     'raca': 'Cesky Terrier'
    //   },
    //   '54': {
    //     'id': '54',
    //     'raca': 'Chesapeake Bay Retriever'
    //   },
    //   '55': {
    //     'id': '55',
    //     'raca': 'Chihuahua'
    //   },
    //   '56': {
    //     'id': '56',
    //     'raca': 'Chin'
    //   },
    //   '113': {
    //     'id': '113',
    //     'raca': 'Chow-chow Pelo Curto'
    //   },
    //   '114': {
    //     'id': '114',
    //     'raca': 'Chow-chow Pelo Longo'
    //   },
    //   '115': {
    //     'id': '115',
    //     'raca': 'Cimarrón perro'
    //   },
    //   '116': {
    //     'id': '116',
    //     'raca': 'Cirneco do Etna'
    //   },
    //   '117': {
    //     'id': '117',
    //     'raca': 'Clumber Spaniel'
    //   },
    //   '118': {
    //     'id': '118',
    //     'raca': 'Cocker Spaniel Americano'
    //   },
    //   '119': {
    //     'id': '119',
    //     'raca': 'Cocker Spaniel Inglês'
    //   },
    //   '120': {
    //     'id': '120',
    //     'raca': 'Collie pelo longo'
    //   },
    //   '121': {
    //     'id': '121',
    //     'raca': 'Coton de Tulear'
    //   },
    //   '122': {
    //     'id': '122',
    //     'raca': 'Dachshund Teckel - Pelo Curto'
    //   },
    //   '123': {
    //     'id': '123',
    //     'raca': 'Dachshund Teckel - Pelo Duro'
    //   },
    //   '124': {
    //     'id': '124',
    //     'raca': 'Dachshund Teckel - Pelo Longo'
    //   },
    //   '125': {
    //     'id': '125',
    //     'raca': 'Dálmata'
    //   },
    //   '126': {
    //     'id': '126',
    //     'raca': 'Dandie Dinmont Terrier'
    //   },
    //   '127': {
    //     'id': '127',
    //     'raca': 'Dobermann'
    //   },
    //   '128': {
    //     'id': '128',
    //     'raca': 'Dogo Argentino'
    //   },
    //   '129': {
    //     'id': '129',
    //     'raca': 'Dogo Canário'
    //   },
    //   '130': {
    //     'id': '130',
    //     'raca': 'Dogue Alemão'
    //   },
    //   '131': {
    //     'id': '131',
    //     'raca': 'Dogue Brasileiro'
    //   },
    //   '132': {
    //     'id': '132',
    //     'raca': 'Dogue de Bordeaux'
    //   },
    //   '133': {
    //     'id': '133',
    //     'raca': 'Drever'
    //   },
    //   '134': {
    //     'id': '134',
    //     'raca': 'Elkhound Norueguês Cinza'
    //   },
    //   '135': {
    //     'id': '135',
    //     'raca': 'Fila Brasileiro'
    //   },
    //   '136': {
    //     'id': '136',
    //     'raca': 'Flat-Coated Retriever'
    //   },
    //   '137': {
    //     'id': '137',
    //     'raca': 'Fox Terrier Pelo Duro '
    //   },
    //   '138': {
    //     'id': '138',
    //     'raca': 'Fox Terrier Pelo Liso'
    //   },
    //   '139': {
    //     'id': '139',
    //     'raca': 'Foxhound Americano'
    //   },
    //   '140': {
    //     'id': '140',
    //     'raca': 'Foxhound Inglês'
    //   },
    //   '141': {
    //     'id': '141',
    //     'raca': 'Galgo Espanhol'
    //   },
    //   '142': {
    //     'id': '142',
    //     'raca': 'Golden Retriever'
    //   },
    //   '143': {
    //     'id': '143',
    //     'raca': 'Grande Azul da Gasconha'
    //   },
    //   '144': {
    //     'id': '144',
    //     'raca': 'Grande Münsterländer'
    //   },
    //   '145': {
    //     'id': '145',
    //     'raca': 'Greyhound'
    //   },
    //   '146': {
    //     'id': '146',
    //     'raca': 'Griffon Belga'
    //   },
    //   '147': {
    //     'id': '147',
    //     'raca': 'Griffon de Bruxelas'
    //   },
    //   '148': {
    //     'id': '148',
    //     'raca': 'Griffon Nivernais'
    //   },
    //   '149': {
    //     'id': '149',
    //     'raca': 'Hokkaido'
    //   },
    //   '150': {
    //     'id': '150',
    //     'raca': 'Husky Siberiano'
    //   },
    //   '151': {
    //     'id': '151',
    //     'raca': 'Ibizan Hound'
    //   },
    //   '152': {
    //     'id': '152',
    //     'raca': 'Irish Soft Coated Wheaten Terrier'
    //   },
    //   '153': {
    //     'id': '153',
    //     'raca': 'Irish Wolfhound'
    //   },
    //   '154': {
    //     'id': '154',
    //     'raca': 'Jack Russell Terrier'
    //   },
    //   '155': {
    //     'id': '155',
    //     'raca': 'Kerry Blue Terrier'
    //   },
    //   '156': {
    //     'id': '156',
    //     'raca': 'Komondor'
    //   },
    //   '157': {
    //     'id': '157',
    //     'raca': 'Kromfohrländer'
    //   },
    //   '158': {
    //     'id': '158',
    //     'raca': 'Kuvasz'
    //   },
    //   '159': {
    //     'id': '159',
    //     'raca': 'Labrador Retriever'
    //   },
    //   '160': {
    //     'id': '160',
    //     'raca': 'Lagotto Romagnolo'
    //   },
    //   '161': {
    //     'id': '161',
    //     'raca': 'Lakeland Terrier'
    //   },
    //   '162': {
    //     'id': '162',
    //     'raca': 'Leonberger'
    //   },
    //   '163': {
    //     'id': '163',
    //     'raca': 'Lhasa Apso'
    //   },
    //   '164': {
    //     'id': '164',
    //     'raca': 'Malamute do Alasca'
    //   },
    //   '165': {
    //     'id': '165',
    //     'raca': 'Maltês'
    //   },
    //   '166': {
    //     'id': '166',
    //     'raca': 'Mastiff'
    //   },
    //   '167': {
    //     'id': '167',
    //     'raca': 'Mastino Napoletano'
    //   },
    //   '168': {
    //     'id': '168',
    //     'raca': 'Mudi'
    //   },
    //   '169': {
    //     'id': '169',
    //     'raca': 'Nordic Spitz'
    //   },
    //   '170': {
    //     'id': '170',
    //     'raca': 'Norfolk Terrier'
    //   },
    //   '171': {
    //     'id': '171',
    //     'raca': 'Norwich Terrier'
    //   },
    //   '172': {
    //     'id': '172',
    //     'raca': 'Old English Sheepdog'
    //   },
    //   '173': {
    //     'id': '173',
    //     'raca': 'Ovelheiro gaúcho'
    //   },
    //   '174': {
    //     'id': '174',
    //     'raca': 'Papillon'
    //   },
    //   '175': {
    //     'id': '175',
    //     'raca': 'Parson Russell Terrier'
    //   },
    //   '176': {
    //     'id': '176',
    //     'raca': 'Pastor Alemão'
    //   },
    //   '177': {
    //     'id': '177',
    //     'raca': 'Pastor Beauceron'
    //   },
    //   '178': {
    //     'id': '178',
    //     'raca': 'Pastor Belga'
    //   },
    //   '179': {
    //     'id': '179',
    //     'raca': 'Pastor Bergamasco'
    //   },
    //   '180': {
    //     'id': '180',
    //     'raca': 'Pastor Branco Suíço'
    //   },
    //   '181': {
    //     'id': '181',
    //     'raca': 'Pastor Briard'
    //   },
    //   '182': {
    //     'id': '182',
    //     'raca': 'Pastor da Ásia Central'
    //   },
    //   '183': {
    //     'id': '183',
    //     'raca': 'Pastor de Shetland'
    //   },
    //   '184': {
    //     'id': '184',
    //     'raca': 'Pastor dos Pirineus'
    //   },
    //   '185': {
    //     'id': '185',
    //     'raca': 'Pastor Holandês'
    //   },
    //   '186': {
    //     'id': '186',
    //     'raca': 'Pastor Maremano Abruzês'
    //   },
    //   '187': {
    //     'id': '187',
    //     'raca': 'Pastor Polonês da Planície'
    //   },
    //   '188': {
    //     'id': '188',
    //     'raca': 'Pastor Polonês'
    //   },
    //   '189': {
    //     'id': '189',
    //     'raca': 'Pequeno Basset Griffon da Vendéia'
    //   },
    //   '190': {
    //     'id': '190',
    //     'raca': 'Pequeno Cão Leão'
    //   },
    //   '191': {
    //     'id': '191',
    //     'raca': 'Pequeno Lebrel Italiano'
    //   },
    //   '192': {
    //     'id': '192',
    //     'raca': 'Pequinês'
    //   },
    //   '193': {
    //     'id': '193',
    //     'raca': 'Perdigueiro Português'
    //   },
    //   '194': {
    //     'id': '194',
    //     'raca': 'Petit Brabançon'
    //   },
    //   '195': {
    //     'id': '195',
    //     'raca': 'Pharaoh Hound'
    //   },
    //   '196': {
    //     'id': '196',
    //     'raca': 'Pinscher Miniatura'
    //   },
    //   '197': {
    //     'id': '197',
    //     'raca': 'Podengo Canário'
    //   },
    //   '198': {
    //     'id': '198',
    //     'raca': 'Podengo Português'
    //   },
    //   '199': {
    //     'id': '199',
    //     'raca': 'Pointer Inglês'
    //   },
    //   '200': {
    //     'id': '200',
    //     'raca': 'Poodle Anão'
    //   },
    //   '201': {
    //     'id': '201',
    //     'raca': 'Poodle Médio'
    //   },
    //   '202': {
    //     'id': '202',
    //     'raca': 'Poodle Standard'
    //   },
    //   '203': {
    //     'id': '203',
    //     'raca': 'Poodle Toy'
    //   },
    //   '204': {
    //     'id': '204',
    //     'raca': 'Pug'
    //   },
    //   '205': {
    //     'id': '205',
    //     'raca': 'Puli'
    //   },
    //   '206': {
    //     'id': '206',
    //     'raca': 'Pumi'
    //   },
    //   '207': {
    //     'id': '207',
    //     'raca': 'Rafeiro do Alentejo'
    //   },
    //   '208': {
    //     'id': '208',
    //     'raca': 'Rhodesian Ridgeback'
    //   },
    //   '209': {
    //     'id': '209',
    //     'raca': 'Rottweiler'
    //   },
    //   '210': {
    //     'id': '210',
    //     'raca': 'Saluki'
    //   },
    //   '211': {
    //     'id': '211',
    //     'raca': 'Samoieda'
    //   },
    //   '212': {
    //     'id': '212',
    //     'raca': 'São Bernardo'
    //   },
    //   '213': {
    //     'id': '213',
    //     'raca': 'Schipperke'
    //   },
    //   '214': {
    //     'id': '214',
    //     'raca': 'Schnauzer'
    //   },
    //   '215': {
    //     'id': '215',
    //     'raca': 'Schnauzer Gigante'
    //   },
    //   '216': {
    //     'id': '216',
    //     'raca': 'Schnauzer Miniatura'
    //   },
    //   '217': {
    //     'id': '217',
    //     'raca': 'Scottish Terrier'
    //   },
    //   '218': {
    //     'id': '218',
    //     'raca': 'Sealyham Terrier'
    //   },
    //   '219': {
    //     'id': '219',
    //     'raca': 'Setter Gordon'
    //   },
    //   '220': {
    //     'id': '220',
    //     'raca': 'Setter Inglês'
    //   },
    //   '221': {
    //     'id': '221',
    //     'raca': 'Setter Irlandês Vermelho'
    //   },
    //   '222': {
    //     'id': '222',
    //     'raca': 'Setter Irlandês Vermelho e Branco'
    //   },
    //   '223': {
    //     'id': '223',
    //     'raca': 'Shar-pei'
    //   },
    //   '224': {
    //     'id': '224',
    //     'raca': 'Shiba'
    //   },
    //   '225': {
    //     'id': '225',
    //     'raca': 'Shih-Tzu'
    //   },
    //   '226': {
    //     'id': '226',
    //     'raca': 'Silky Terrier Australiano'
    //   },
    //   '227': {
    //     'id': '227',
    //     'raca': 'Skye Terrier'
    //   },
    //   '228': {
    //     'id': '228',
    //     'raca': 'Smoushond Holandês'
    //   },
    //   '229': {
    //     'id': '229',
    //     'raca': 'Spaniel Bretão'
    //   },
    //   '230': {
    //     'id': '230',
    //     'raca': 'Spinone Italiano'
    //   },
    //   '231': {
    //     'id': '231',
    //     'raca': 'Spitz Alemão Anão'
    //   },
    //   '232': {
    //     'id': '232',
    //     'raca': 'Spitz Finlandês'
    //   },
    //   '233': {
    //     'id': '233',
    //     'raca': 'Spitz Japonês Anão'
    //   },
    //   '234': {
    //     'id': '234',
    //     'raca': 'Springer Spaniel Inglês'
    //   },
    //   '235': {
    //     'id': '235',
    //     'raca': 'Stabyhoun'
    //   },
    //   '236': {
    //     'id': '236',
    //     'raca': 'Staffordshire Bull Terrier'
    //   },
    //   '237': {
    //     'id': '237',
    //     'raca': 'Terra Nova'
    //   },
    //   '238': {
    //     'id': '238',
    //     'raca': 'Terrier Alemão de caça Jagd'
    //   },
    //   '239': {
    //     'id': '239',
    //     'raca': 'Terrier Australiano'
    //   },
    //   '240': {
    //     'id': '240',
    //     'raca': 'Terrier Brasileiro'
    //   },
    //   '241': {
    //     'id': '241',
    //     'raca': 'Terrier Irlandês de Glen do Imaal'
    //   },
    //   '242': {
    //     'id': '242',
    //     'raca': 'Terrier Preto da Rússia'
    //   },
    //   '243': {
    //     'id': '243',
    //     'raca': 'Tibetan Terrier'
    //   },
    //   '244': {
    //     'id': '244',
    //     'raca': 'Tosa Inu'
    //   },
    //   '245': {
    //     'id': '245',
    //     'raca': 'Toy Fox Terrier'
    //   },
    //   '246': {
    //     'id': '246',
    //     'raca': 'Tricolor Francês'
    //   },
    //   '247': {
    //     'id': '247',
    //     'raca': 'Veadeiro Pampeano'
    //   },
    //   '248': {
    //     'id': '248',
    //     'raca': 'Vizsla'
    //   },
    //   '249': {
    //     'id': '249',
    //     'raca': 'Volpino Italiano'
    //   },
    //   '250': {
    //     'id': '250',
    //     'raca': 'Weimaraner'
    //   },
    //   '251': {
    //     'id': '251',
    //     'raca': 'Welsh Corgi Cardigan'
    //   },
    //   '252': {
    //     'id': '252',
    //     'raca': 'Welsh Corgi Pembroke'
    //   },
    //   '253': {
    //     'id': '253',
    //     'raca': 'Welsh Springer Spaniel'
    //   },
    //   '254': {
    //     'id': '254',
    //     'raca': 'Welsh Terrier'
    //   },
    //   '255': {
    //     'id': '255',
    //     'raca': 'West Highland White Terrier'
    //   },
    //   '256': {
    //     'id': '256',
    //     'raca': 'Wetterhoun'
    //   },
    //   '257': {
    //     'id': '257',
    //     'raca': 'Whippet'
    //   },
    //   '258': {
    //     'id': '258',
    //     'raca': 'Yorkshire Terrier'
    //   },
    //   '360': {
    //     'id': '360',
    //     'raca': 'SRD - Sem Raça Definida'
    //   },
    //   '403': {
    //     'id': '403',
    //     'raca': 'Vira-Latas'
    //   }
    // };

    // const racasFelinas = {
    //   '259': {
    //     'id': '259',
    //     'raca': 'Abyssinian'
    //   },
    //   '260': {
    //     'id': '260',
    //     'raca': 'American Bobtail Longhair'
    //   },
    //   '261': {
    //     'id': '261',
    //     'raca': 'American Bobtail Shorthair'
    //   },
    //   '262': {
    //     'id': '262',
    //     'raca': 'American Shorthair'
    //   },
    //   '263': {
    //     'id': '263',
    //     'raca': 'American Wirehair'
    //   },
    //   '264': {
    //     'id': '264',
    //     'raca': 'Anatoli'
    //   },
    //   '265': {
    //     'id': '265',
    //     'raca': 'Arabian Mau'
    //   },
    //   '266': {
    //     'id': '266',
    //     'raca': 'Ashera'
    //   },
    //   '267': {
    //     'id': '267',
    //     'raca': 'Asian Semi-long Hair'
    //   },
    //   '268': {
    //     'id': '268',
    //     'raca': 'Australian Mist'
    //   },
    //   '269': {
    //     'id': '269',
    //     'raca': 'Balinês'
    //   },
    //   '270': {
    //     'id': '270',
    //     'raca': 'Bengal'
    //   },
    //   '271': {
    //     'id': '271',
    //     'raca': 'Bobtail Japonês'
    //   },
    //   '272': {
    //     'id': '272',
    //     'raca': 'Bombaim'
    //   },
    //   '273': {
    //     'id': '273',
    //     'raca': 'Brazilian Shorthair'
    //   },
    //   '274': {
    //     'id': '274',
    //     'raca': 'British Longhair'
    //   },
    //   '275': {
    //     'id': '275',
    //     'raca': 'British Shorthair'
    //   },
    //   '276': {
    //     'id': '276',
    //     'raca': 'Burmês'
    //   },
    //   '277': {
    //     'id': '277',
    //     'raca': 'Burmilla'
    //   },
    //   '278': {
    //     'id': '278',
    //     'raca': 'California Spangled Cat'
    //   },
    //   '279': {
    //     'id': '279',
    //     'raca': 'Ceylon'
    //   },
    //   '280': {
    //     'id': '280',
    //     'raca': 'Chartreux'
    //   },
    //   '281': {
    //     'id': '281',
    //     'raca': 'Chausie'
    //   },
    //   '282': {
    //     'id': '282',
    //     'raca': 'Cheetoh'
    //   },
    //   '283': {
    //     'id': '283',
    //     'raca': 'Chinchilla Longhair'
    //   },
    //   '284': {
    //     'id': '284',
    //     'raca': 'Cornish Rex'
    //   },
    //   '285': {
    //     'id': '285',
    //     'raca': 'Curl Americano Pelo Curto'
    //   },
    //   '286': {
    //     'id': '286',
    //     'raca': 'Curl Americano Pelo Longo'
    //   },
    //   '287': {
    //     'id': '287',
    //     'raca': 'Cymric'
    //   },
    //   '288': {
    //     'id': '288',
    //     'raca': 'Devon Rex'
    //   },
    //   '289': {
    //     'id': '289',
    //     'raca': 'Domestic Long-Haired'
    //   },
    //   '290': {
    //     'id': '290',
    //     'raca': 'Domestic Short-Haired'
    //   },
    //   '291': {
    //     'id': '291',
    //     'raca': 'Don Sphynx'
    //   },
    //   '292': {
    //     'id': '292',
    //     'raca': 'Egyptian Mau'
    //   },
    //   '293': {
    //     'id': '293',
    //     'raca': 'European'
    //   },
    //   '294': {
    //     'id': '294',
    //     'raca': 'Exotic Longhair'
    //   },
    //   '295': {
    //     'id': '295',
    //     'raca': 'Exotic Shorthair'
    //   },
    //   '296': {
    //     'id': '296',
    //     'raca': 'Foldex'
    //   },
    //   '297': {
    //     'id': '297',
    //     'raca': 'German Rex'
    //   },
    //   '298': {
    //     'id': '298',
    //     'raca': 'Havana'
    //   },
    //   '299': {
    //     'id': '299',
    //     'raca': 'Highland Lynx'
    //   },
    //   '300': {
    //     'id': '300',
    //     'raca': 'Highlander Longhair'
    //   },
    //   '301': {
    //     'id': '301',
    //     'raca': 'Highlander Shorthair'
    //   },
    //   '302': {
    //     'id': '302',
    //     'raca': 'Himalaio'
    //   },
    //   '303': {
    //     'id': '303',
    //     'raca': 'Honey Bear'
    //   },
    //   '304': {
    //     'id': '304',
    //     'raca': 'Kanaani'
    //   },
    //   '305': {
    //     'id': '305',
    //     'raca': 'Karelian Bobtail Longhair'
    //   },
    //   '306': {
    //     'id': '306',
    //     'raca': 'Karelian Bobtail Shorthair'
    //   },
    //   '307': {
    //     'id': '307',
    //     'raca': 'Khao Manee'
    //   },
    //   '308': {
    //     'id': '308',
    //     'raca': 'Korat'
    //   },
    //   '309': {
    //     'id': '309',
    //     'raca': 'Kurilian Bobtail Longhair'
    //   },
    //   '310': {
    //     'id': '310',
    //     'raca': 'Kurilian Bobtail Shorthair'
    //   },
    //   '311': {
    //     'id': '311',
    //     'raca': 'LaPerm Longhair'
    //   },
    //   '312': {
    //     'id': '312',
    //     'raca': 'LaPerm Shorthair'
    //   },
    //   '313': {
    //     'id': '313',
    //     'raca': 'Maine Coon'
    //   },
    //   '314': {
    //     'id': '314',
    //     'raca': 'Manx'
    //   },
    //   '315': {
    //     'id': '315',
    //     'raca': 'Mekong Bobtail'
    //   },
    //   '316': {
    //     'id': '316',
    //     'raca': 'Minskin'
    //   },
    //   '317': {
    //     'id': '317',
    //     'raca': 'Munchkin Longhair'
    //   },
    //   '318': {
    //     'id': '318',
    //     'raca': 'Munchkin Shorthair'
    //   },
    //   '319': {
    //     'id': '319',
    //     'raca': 'Napoleon'
    //   },
    //   '320': {
    //     'id': '320',
    //     'raca': 'Napoleon Longhair'
    //   },
    //   '321': {
    //     'id': '321',
    //     'raca': 'Nebelung'
    //   },
    //   '322': {
    //     'id': '322',
    //     'raca': 'Norwegian Forest Cat'
    //   },
    //   '323': {
    //     'id': '323',
    //     'raca': 'Ocicat'
    //   },
    //   '324': {
    //     'id': '324',
    //     'raca': 'Ojos Azules Longhair'
    //   },
    //   '325': {
    //     'id': '325',
    //     'raca': 'Ojos Azules Shorthair'
    //   },
    //   '326': {
    //     'id': '326',
    //     'raca': 'Oriental Longhair'
    //   },
    //   '327': {
    //     'id': '327',
    //     'raca': 'Oriental Shorthair'
    //   },
    //   '328': {
    //     'id': '328',
    //     'raca': 'Persa'
    //   },
    //   '329': {
    //     'id': '329',
    //     'raca': 'Peterbald'
    //   },
    //   '330': {
    //     'id': '330',
    //     'raca': 'Pixiebob Longhair'
    //   },
    //   '331': {
    //     'id': '331',
    //     'raca': 'Pixiebob Shorthair'
    //   },
    //   '332': {
    //     'id': '332',
    //     'raca': 'Ragamuffin'
    //   },
    //   '333': {
    //     'id': '333',
    //     'raca': 'Ragdoll'
    //   },
    //   '334': {
    //     'id': '334',
    //     'raca': 'Russo Azul'
    //   },
    //   '335': {
    //     'id': '335',
    //     'raca': 'Sagrado da Birmânia'
    //   },
    //   '336': {
    //     'id': '336',
    //     'raca': 'Savannah Cat'
    //   },
    //   '337': {
    //     'id': '337',
    //     'raca': 'Scottish Fold'
    //   },
    //   '338': {
    //     'id': '338',
    //     'raca': 'Selkirk Rex Longhair'
    //   },
    //   '339': {
    //     'id': '339',
    //     'raca': 'Selkirk Rex Shorthair'
    //   },
    //   '340': {
    //     'id': '340',
    //     'raca': 'Serengeti'
    //   },
    //   '341': {
    //     'id': '341',
    //     'raca': 'Seychellois Longhair'
    //   },
    //   '342': {
    //     'id': '342',
    //     'raca': 'Seychellois Shortghair'
    //   },
    //   '343': {
    //     'id': '343',
    //     'raca': 'Siamês'
    //   },
    //   '344': {
    //     'id': '344',
    //     'raca': 'Siberian'
    //   },
    //   '345': {
    //     'id': '345',
    //     'raca': 'Singapura'
    //   },
    //   '346': {
    //     'id': '346',
    //     'raca': 'Snowshoe'
    //   },
    //   '347': {
    //     'id': '347',
    //     'raca': 'Sokoke'
    //   },
    //   '348': {
    //     'id': '348',
    //     'raca': 'Somali'
    //   },
    //   '349': {
    //     'id': '349',
    //     'raca': 'Sphynx'
    //   },
    //   '350': {
    //     'id': '350',
    //     'raca': 'Thai'
    //   },
    //   '351': {
    //     'id': '351',
    //     'raca': 'Tonkinese Longhair'
    //   },
    //   '352': {
    //     'id': '352',
    //     'raca': 'Tonkinese Shorthair'
    //   },
    //   '353': {
    //     'id': '353',
    //     'raca': 'Toyger'
    //   },
    //   '354': {
    //     'id': '354',
    //     'raca': 'Turkish Angorá'
    //   },
    //   '355': {
    //     'id': '355',
    //     'raca': 'Turkish Van'
    //   },
    //   '356': {
    //     'id': '356',
    //     'raca': 'Turkish Vankedisi'
    //   },
    //   '357': {
    //     'id': '357',
    //     'raca': 'Ural Rex Longhair'
    //   },
    //   '358': {
    //     'id': '358',
    //     'raca': 'Ural Rex Shorthair'
    //   },
    //   '359': {
    //     'id': '359',
    //     'raca': 'York Chocolate'
    //   },
    //   '361': {
    //     'id': '361',
    //     'raca': 'SRD - Sem raça definida'
    //   }
    // };

    // const ids = Object.keys(racasFelinas);

    // const batch = this._firestore.firestore.batch();
    // let breedRef;
    // let fireId;

    // ids.forEach(id => {

    //   fireId = this._firestore.createId();

    //   console.log(id, racasFelinas[id], fireId, racasFelinas[id].raca);

    //   breedRef = this._firestore.firestore.collection('species').doc('felino').collection('breeds').doc(this._firestore.createId());
    //   batch.set(breedRef, { name: racasFelinas[id].raca });

    // });

    // console.log('vai comitar');

    // batch.commit().then(function () {
    //   console.log('comitou');
    // });
  } */
}
